import { change } from 'redux-form';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { checkUserExists as mutation } from '../../../lib/graphql';


export const checkUserExists = (variables) => {

    try {
        return async (dispatch, getState, { client }) => {

            dispatch(change("ManualBookingForm", "loaders.stepOne", true));
            const { data } = await client.mutate({
                mutation,
                variables
            });

            if (data && data.checkUserExists && data.checkUserExists.status === 200) {
                let result = data.checkUserExists.result || {};
                await dispatch(change("ManualBookingForm", 'bookingType', 1));
                await dispatch(change("ManualBookingForm", 'userId', result.id));
                await dispatch(change("ManualBookingForm", 'firstName', result.profile && result.profile.firstName));
                await dispatch(change("ManualBookingForm", 'lastName', result.profile && result.profile.lastName));
                await dispatch(change("ManualBookingForm", 'email', result.email));
                // Payment context (cash removed → book on the client's saved card or wallet)
                await dispatch(change("ManualBookingForm", 'walletBalance', result.walletBalance != null ? result.walletBalance : 0));
                await dispatch(change("ManualBookingForm", 'cardLast4', result.cardLast4 || null));
                await dispatch(change("ManualBookingForm", 'cardBrand', result.cardBrand || null));
                await dispatch(change("ManualBookingForm", 'cardPaymentMethodId', result.cardPaymentMethodId || null));
                // Default selection: card if one is on file, else wallet (when funded)
                await dispatch(change("ManualBookingForm", 'paymentType', result.cardPaymentMethodId ? 2 : (Number(result.walletBalance) > 0 ? 3 : null)));
                await dispatch(change("ManualBookingForm", 'stepTwoEnabled', true));
            } else if (data?.checkUserExists?.status !== 200) {
                showToaster({ messageId: 'errorMessage', requestContent: data?.checkUserExists?.errorMessage, toasterType: 'error' });
            }

            dispatch(change("ManualBookingForm", "loaders.stepOne", false));

        }
    } catch (error) {
        dispatch(change("ManualBookingForm", "loaders.stepOne", false));
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
        return false;
    }
}